import { render, staticRenderFns } from "./OTextField.vue?vue&type=template&id=6cd35306&scoped=true&"
import script from "./OTextField.vue?vue&type=script&lang=js&"
export * from "./OTextField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cd35306",
  null
  
)

export default component.exports